export const quizQuestions = [
  {
    id: 'emotional_state',
    question: 'How would you describe your current emotional state?',
    subtitle: 'Think about how you feel most days recently',
    options: [
      { text: 'Devastated, can barely function', value: 1 },
      { text: 'Very sad but getting through each day', value: 2 },
      { text: 'Up and down, some good days and bad days', value: 3 },
      { text: 'Generally stable with occasional sadness', value: 4 },
      { text: 'Feeling positive and optimistic', value: 5 }
    ]
  },
  {
    id: 'daily_functioning',
    question: 'How well are you managing your daily responsibilities?',
    subtitle: 'Work, school, household tasks, self-care, etc.',
    options: [
      { text: 'Struggling with basic tasks, everything feels overwhelming', value: 1 },
      { text: 'Getting by but with much more effort than usual', value: 2 },
      { text: 'Managing most things but some areas are suffering', value: 3 },
      { text: 'Back to normal routine with minor adjustments', value: 4 },
      { text: 'Functioning well, possibly better than before', value: 5 }
    ]
  },
  {
    id: 'thoughts_about_ex',
    question: 'How often do you think about your ex-partner?',
    subtitle: 'Be honest about the frequency and intensity',
    options: [
      { text: 'Constantly, they dominate my thoughts', value: 1 },
      { text: 'Multiple times daily, hard to focus on other things', value: 2 },
      { text: 'Daily but I can redirect my attention', value: 3 },
      { text: 'Occasionally, usually triggered by specific things', value: 4 },
      { text: 'Rarely, and when I do it\'s neutral or positive', value: 5 }
    ]
  },
  {
    id: 'contact_with_ex',
    question: 'What is your current contact situation with your ex?',
    options: [
      { text: 'Trying to contact them frequently, checking their social media obsessively', value: 1 },
      { text: 'Limited contact but still reaching out sometimes', value: 2 },
      { text: 'Minimal contact, only when necessary', value: 3 },
      { text: 'No contact by choice, maintaining boundaries', value: 4 },
      { text: 'Comfortable with appropriate contact level (or no contact)', value: 5 }
    ]
  },
  {
    id: 'sleep_patterns',
    question: 'How has the breakup affected your sleep?',
    options: [
      { text: 'Severe insomnia or sleeping too much, very disrupted', value: 1 },
      { text: 'Noticeable sleep issues, often tired', value: 2 },
      { text: 'Some sleep disruption but improving', value: 3 },
      { text: 'Mostly back to normal sleep patterns', value: 4 },
      { text: 'Sleeping well, feeling rested', value: 5 }
    ]
  },
  {
    id: 'social_connections',
    question: 'How are you managing your social relationships?',
    options: [
      { text: 'Isolating myself, avoiding friends and family', value: 1 },
      { text: 'Seeing people but not enjoying it much', value: 2 },
      { text: 'Selectively social, some good moments with others', value: 3 },
      { text: 'Actively maintaining friendships and making plans', value: 4 },
      { text: 'Thriving socially, possibly meeting new people', value: 5 }
    ]
  },
  {
    id: 'self_care',
    question: 'How well are you taking care of yourself?',
    subtitle: 'Exercise, nutrition, hygiene, hobbies, etc.',
    options: [
      { text: 'Neglecting basic self-care', value: 1 },
      { text: 'Doing the minimum to get by', value: 2 },
      { text: 'Inconsistent but making some effort', value: 3 },
      { text: 'Good self-care routine, prioritizing my wellbeing', value: 4 },
      { text: 'Excellent self-care, exploring new healthy habits', value: 5 }
    ]
  },
  {
    id: 'future_outlook',
    question: 'How do you feel about your future?',
    options: [
      { text: 'Can\'t imagine a future without them, feels hopeless', value: 1 },
      { text: 'Worried about the future, lots of uncertainty', value: 2 },
      { text: 'Cautiously optimistic, taking it day by day', value: 3 },
      { text: 'Excited about new possibilities and opportunities', value: 4 },
      { text: 'Confident and enthusiastic about what\'s ahead', value: 5 }
    ]
  },
  {
    id: 'anger_processing',
    question: 'How are you dealing with any anger or resentment?',
    options: [
      { text: 'Consumed by anger, can\'t let go of resentment', value: 1 },
      { text: 'Very angry but trying to process it', value: 2 },
      { text: 'Working through anger in healthy ways', value: 3 },
      { text: 'Mostly processed anger, occasional flare-ups', value: 4 },
      { text: 'At peace with the situation, no significant anger', value: 5 }
    ]
  },
  {
    id: 'new_relationships',
    question: 'How do you feel about the possibility of dating again?',
    options: [
      { text: 'Absolutely not ready, can\'t imagine being with anyone else', value: 1 },
      { text: 'Not ready but sometimes wonder about it', value: 2 },
      { text: 'Open to the idea but not actively looking', value: 3 },
      { text: 'Ready to date casually when the right person comes along', value: 4 },
      { text: 'Confident and excited about meeting someone new', value: 5 }
    ]
  },
  {
    id: 'personal_growth',
    question: 'How much personal growth have you experienced?',
    options: [
      { text: 'Feel like I\'ve lost myself completely', value: 1 },
      { text: 'Struggling to find who I am without them', value: 2 },
      { text: 'Starting to rediscover myself and my interests', value: 3 },
      { text: 'Learning a lot about myself and growing as a person', value: 4 },
      { text: 'Stronger and more self-aware than ever before', value: 5 }
    ]
  },
  {
    id: 'relationship_reflection',
    question: 'How do you view your past relationship now?',
    options: [
      { text: 'It was perfect, biggest mistake of my life to lose them', value: 1 },
      { text: 'Mostly good memories, focus on what I lost', value: 2 },
      { text: 'Can see both good and bad aspects objectively', value: 3 },
      { text: 'Grateful for lessons learned, ready to apply them', value: 4 },
      { text: 'Appreciate the experience, confident in my relationship skills', value: 5 }
    ]
  }
];

export const calculateResults = (answers) => {
  const totalScore = Object.values(answers).reduce((sum, value) => sum + value, 0);
  const averageScore = totalScore / Object.keys(answers).length;
  const normalizedScore = Math.round((averageScore - 1) * 25); // Convert to 0-100 scale

  let stage;
  if (normalizedScore <= 20) {
    stage = 'raw-pain';
  } else if (normalizedScore <= 40) {
    stage = 'anger-bargaining';
  } else if (normalizedScore <= 60) {
    stage = 'processing';
  } else if (normalizedScore <= 80) {
    stage = 'rebuilding';
  } else {
    stage = 'thriving';
  }

  return {
    score: normalizedScore,
    stage
  };
};

export const stageDetails = {
  'raw-pain': {
    number: 1,
    title: 'Raw Pain & Denial',
    description: 'You\'re in the acute phase of grief. The pain feels overwhelming and you may be struggling to accept the reality of the breakup.',
    characteristics: [
      'Intense emotional pain and crying spells',
      'Difficulty accepting the breakup is real',
      'Overwhelming feelings of loss and emptiness',
      'Trouble with basic daily functioning',
      'Constant thoughts about your ex-partner',
      'Physical symptoms like loss of appetite or sleep issues'
    ],
    recommendations: [
      'Allow yourself to feel the pain without judgment',
      'Reach out to trusted friends or family for support',
      'Consider professional counseling or therapy',
      'Focus on basic self-care: eating, sleeping, hygiene',
      'Avoid major life decisions during this time',
      'Practice grounding techniques when overwhelmed'
    ],
    nextSteps: [
      'Establish a daily routine to provide structure',
      'Join a support group or find online communities',
      'Start a journal to process your emotions',
      'Schedule regular check-ins with supportive people'
    ]
  },
  'anger-bargaining': {
    number: 2,
    title: 'Anger & Bargaining',
    description: 'You\'re processing difficult emotions like anger, resentment, and the desire to reconcile. This is a normal and necessary part of healing.',
    characteristics: [
      'Feelings of anger towards your ex or the situation',
      'Fantasizing about getting back together',
      'Analyzing what went wrong obsessively',
      'Mood swings between different emotions',
      'Desire to contact your ex to "fix" things',
      'Bargaining or making deals with yourself or universe'
    ],
    recommendations: [
      'Find healthy outlets for anger (exercise, journaling, therapy)',
      'Avoid contacting your ex during emotional moments',
      'Practice mindfulness to observe emotions without acting',
      'Challenge thoughts about reconciliation with reality',
      'Set boundaries around social media and mutual friends',
      'Focus on what you can control in your life'
    ],
    nextSteps: [
      'Create a "no contact" plan and stick to it',
      'Develop new coping strategies for difficult emotions',
      'Start exploring activities that bring you joy',
      'Consider what you want to learn from this experience'
    ]
  },
  'processing': {
    number: 3,
    title: 'Processing & Acceptance',
    description: 'You\'re beginning to accept the reality of the breakup and process the relationship more objectively. Healing is underway.',
    characteristics: [
      'More emotional stability with occasional setbacks',
      'Able to see both positive and negative aspects of the relationship',
      'Less frequent thoughts about your ex',
      'Beginning to imagine a future without them',
      'Some days feel normal, others still difficult',
      'Starting to reconnect with your own identity'
    ],
    recommendations: [
      'Continue building healthy daily routines',
      'Explore new interests and rediscover old ones',
      'Strengthen relationships with friends and family',
      'Practice gratitude and mindfulness regularly',
      'Set small, achievable goals for personal growth',
      'Be patient with the non-linear nature of healing'
    ],
    nextSteps: [
      'Identify lessons learned from the relationship',
      'Start planning new experiences and adventures',
      'Work on personal development goals',
      'Consider what you want in future relationships'
    ]
  },
  'rebuilding': {
    number: 4,
    title: 'Rebuilding & Growth',
    description: 'You\'re actively rebuilding your life and identity. You feel more like yourself and are open to new experiences and possibilities.',
    characteristics: [
      'Consistent emotional stability and positive mood',
      'Engaged in personal interests and social activities',
      'Able to think about your ex without intense pain',
      'Feeling confident in your ability to handle challenges',
      'Open to new experiences and meeting new people',
      'Clear sense of personal growth and lessons learned'
    ],
    recommendations: [
      'Continue investing in personal growth and new experiences',
      'Strengthen your support network and social connections',
      'Pursue goals and dreams that are important to you',
      'Practice self-compassion and celebrate your progress',
      'Consider helping others who are going through similar experiences',
      'Reflect on what you want in future relationships'
    ],
    nextSteps: [
      'Set meaningful long-term goals for your life',
      'Consider dating when you feel genuinely ready',
      'Share your story to help others in similar situations',
      'Continue developing emotional intelligence and relationship skills'
    ]
  },
  'thriving': {
    number: 5,
    title: 'Thriving Solo',
    description: 'You\'ve not only recovered but are thriving. You feel confident, fulfilled, and excited about your future, whether single or in a new relationship.',
    characteristics: [
      'Genuinely happy and fulfilled with your life',
      'Strong sense of self and personal identity',
      'Healthy relationships and social connections',
      'Excited about future possibilities and opportunities',
      'Able to reflect on past relationship with gratitude and wisdom',
      'Confident in your ability to handle whatever comes next'
    ],
    recommendations: [
      'Continue nurturing your personal growth and well-being',
      'Maintain the healthy habits and boundaries you\'ve developed',
      'Share your wisdom and support others in their healing journey',
      'Stay open to love while remaining fulfilled on your own',
      'Keep pursuing your passions and dreams',
      'Practice gratitude for how far you\'ve come'
    ],
    nextSteps: [
      'Consider mentoring others going through breakups',
      'Continue setting and achieving meaningful life goals',
      'Stay open to healthy romantic opportunities if desired',
      'Maintain the self-awareness and growth mindset you\'ve developed'
    ]
  }
};